/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   Hook to load the Stream channel id for the conversation about a building,
 * listing, or floor plan
 */

import { useDispatch, useSelector } from 'react-redux'
import { selectIsMessaging3Active } from '../../inspectors/index'
import { selectStreamChannelId } from '../../modules/stream/selectors'
import {
  listingAndBuildingIdToTuple,
  selectFetchedAllStreamChannels,
  selectFetchedUnfilteredChannelsRecently,
  selectStreamChannelOrUnfilteredFetching,
} from '../../modules/stream/selectors/index'
import { loadStreamConversations } from '../../modules/stream/thunks/loadStreamConversations'
import type { BuildingListingIdParams } from '../../modules/stream/types'

export interface UseStreamChannelResult {
  loading: boolean
  streamChannelId: string | null | undefined
}

export const useStreamChannel = (props?: BuildingListingIdParams): UseStreamChannelResult => {
  const dispatch = useDispatch()
  const ids = listingAndBuildingIdToTuple(props)

  const isM3Active = useSelector(selectIsMessaging3Active)
  let loading = useSelector((state) => selectStreamChannelOrUnfilteredFetching(state, ...ids))
  const streamChannelId = useSelector((state) => selectStreamChannelId(state, ...ids))
  const fetchedAllStreamChannels = useSelector(selectFetchedAllStreamChannels)
  const fetchedUnfilteredChannelsRecently = useSelector(selectFetchedUnfilteredChannelsRecently)

  if (isM3Active && loading === undefined) {
    if (!fetchedUnfilteredChannelsRecently) {
      dispatch(loadStreamConversations())
      loading = true
    } else if (
      !fetchedAllStreamChannels &&
      (Boolean(props?.listingId) || Boolean(props?.buildingId))
    ) {
      dispatch(loadStreamConversations(props))
      loading = true
    }
  }
  return { loading: loading ?? false, streamChannelId }
}
